'use client';

import { useState, useEffect } from 'react';

export const usePreloader = () => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.documentElement.classList.add('is-loading');
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
    }

    // Safety timeout: If assets take too long, force the loader to proceed after 2.5 seconds
    const maxWaitTimeout = setTimeout(() => {
      handleLoadComplete();
    }, 1800); 

    const handleLoadComplete = () => {
      clearTimeout(maxWaitTimeout);
      window.removeEventListener('load', handleLoadComplete);
      // We don't set loading to false here because Preloader's GSAP onComplete will flip it.
    };

    if (document.readyState === 'complete') {
      handleLoadComplete();
    } else {
      window.addEventListener('load', handleLoadComplete);
    }

    return () => {
      clearTimeout(maxWaitTimeout);
      window.removeEventListener('load', handleLoadComplete);
    };
  }, []);

  useEffect(() => {
    if (!loading && typeof window !== 'undefined') {
      document.documentElement.classList.remove('is-loading');
      document.body.style.overflow = '';
      document.body.style.height = '';
    }
  }, [loading]);

  return { loading, setLoading };
};